import {
  CurrentMedicationRequests,
  UpcomingVideoConsultations,
} from "./components";

export const MyAgenda = () => {
  return (
    <div className="flex flex-col gap-6">
      <UpcomingVideoConsultations />
      <CurrentMedicationRequests />
    </div>
  );
};
